"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeOfDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var typeOfDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createTypeOf: _factoriesAny.createTypeOf
};
exports.typeOfDependencies = typeOfDependencies;